import * as React from "react";
const SvgFiRrRocket = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-rocket_svg__a)">
      <path
        fill="#062147"
        d="M18 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-4 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-3 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2m12.866-9.042-.075.21C22.289 7.338 20.848 11.3 18 14.82V15a11.02 11.02 0 0 1-3.6 8.135c-.6.553-1.384.862-2.2.865A3.21 3.21 0 0 1 9 20.794v-1.151a4.95 4.95 0 0 1-1.961-1.191L7 18.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L5.586 17l-.039-.038A5 5 0 0 1 4.353 15h-.99A3.366 3.366 0 0 1 .938 9.3 10.92 10.92 0 0 1 9 6h.18C12.7 3.153 16.66 1.712 20.826.21l.216-.076a2.2 2.2 0 0 1 2.824 2.824M3.363 13H4.1a5 5 0 0 1 .891-2.45A25 25 0 0 1 6.8 8.244a8.5 8.5 0 0 0-4.4 2.426c-.253.26-.396.606-.4.968A1.364 1.364 0 0 0 3.363 13M15.7 17.252a26 26 0 0 1-2.252 1.759 5 5 0 0 1-2.448.876v.907A1.207 1.207 0 0 0 12.207 22a1.27 1.27 0 0 0 .852-.345 9 9 0 0 0 2.641-4.403m6.237-15.19a.19.19 0 0 0-.217-.047l-.215.078c-4.844 1.745-9.027 3.253-12.629 6.854A21 21 0 0 0 6.628 11.7a3 3 0 0 0 .333 3.85l1.492 1.49a3 3 0 0 0 3.849.335c.98-.67 1.9-1.422 2.751-2.248 3.6-3.6 5.11-7.787 6.856-12.633l.076-.211a.19.19 0 0 0-.048-.22"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-rocket_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrRocket;
